import * as addresses from './endpoints/addresses';
import * as authentication from './endpoints/authentication';
import * as baskets from './endpoints/baskets';
import * as bottomSheet from './endpoints/bottomSheet';
import * as brand from './endpoints/brand';
import * as dismissibleMessaging from './endpoints/dismissibleMessaging';
import * as favorites from './endpoints/favorites';
import * as grace from './endpoints/grace';
import * as home from './endpoints/home.js';
import * as idMeVerification from './endpoints/idMeVerification.js';
import * as mealAddons from './endpoints/mealAddons';
import * as mealAddonSelections from './endpoints/mealAddonSelections';
import * as mealNotes from './endpoints/mealNotes';
import * as meals from './endpoints/meals';
import * as mealSelections from './endpoints/mealSelections';
import * as menus from './endpoints/menus';
import * as menuSearch from './endpoints/menuSearch';
import * as nutritionalFacts from './endpoints/nutritionalFacts';
import * as offerRewards from './endpoints/offerRewards';
import * as optIns from './endpoints/optIns';
import * as optInSelections from './endpoints/optInSelections';
import * as partnerDeals from './endpoints/partnerDeals';
import * as pastReceipts from './endpoints/pastReceipts';
import * as pauseOfferRewards from './endpoints/pauseOfferRewards';
import * as pauseReasons from './endpoints/pauseReasons';
import * as previousBaskets from './endpoints/previousBaskets';
import * as promotions from './endpoints/promotions';
import * as quickFilters from './endpoints/quickFilters';
import * as recommendedMeals from './endpoints/recommendedMeals';
import * as restartCampaign from './endpoints/restartCampaign';
import * as reviewableMeals from './endpoints/reviewableMeals';
import * as reviews from './endpoints/reviews';
import * as sendABox from './endpoints/sendABox';
import * as shoppingListMeals from './endpoints/shoppingListMeals';
import * as signUp from './endpoints/signUp';
import * as streakOffers from './endpoints/streakOffers';
import * as suggestedPairings from './endpoints/suggestedPairings';
import * as user from './endpoints/user';
import * as userOffers from './endpoints/user_offers';
import * as userMessages from './endpoints/userMessages';
import * as analytics from './endpoints/v3/analytics';
import * as basketsV3 from './endpoints/v3/baskets';
import * as experiments from './endpoints/v3/experiments';
import * as featureFlags from './endpoints/v3/featureFlags';
import * as mealBadgesV3 from './endpoints/v3/mealBadges';
import * as mealPricesV3 from './endpoints/v3/mealPrices';
import * as mealReviewStats from './endpoints/v3/mealReviewStats';
import * as mealSelloutsV3 from './endpoints/v3/mealSellouts';
import * as menusV3 from './endpoints/v3/menus';
import * as permissions from './endpoints/v3/permissions';
import * as quickFiltersV3 from './endpoints/v3/quickFilters';
import * as getCompletedReviewsV3 from './endpoints/v3/reviews';
import * as userV3 from './endpoints/v3/user';
import * as userBehavioralDiscountClaims from './endpoints/v3/userBehavioralDiscountClaims';
import * as userBehavioralDiscounts from './endpoints/v3/userBehavioralDiscounts';

export default {
  ...authentication,
  ...addresses,
  ...baskets,
  ...bottomSheet,
  ...brand,
  ...dismissibleMessaging,
  ...favorites,
  ...grace,
  ...idMeVerification,
  ...home,
  ...meals,
  ...mealAddons,
  ...mealAddonSelections,
  ...mealNotes,
  ...mealSelections,
  ...menus,
  ...menuSearch,
  ...nutritionalFacts,
  ...offerRewards,
  ...optIns,
  ...optInSelections,
  ...partnerDeals,
  ...pastReceipts,
  ...pauseOfferRewards,
  ...pauseReasons,
  ...previousBaskets,
  ...promotions,
  ...quickFilters,
  ...recommendedMeals,
  ...reviews,
  ...reviewableMeals,
  ...restartCampaign,
  ...sendABox,
  ...shoppingListMeals,
  ...signUp,
  ...streakOffers,
  ...suggestedPairings,
  ...user,
  ...userMessages,
  ...userOffers,
  v3: {
    ...analytics,
    ...basketsV3,
    ...experiments,
    ...featureFlags,
    ...getCompletedReviewsV3,
    ...mealBadgesV3,
    ...mealPricesV3,
    ...mealReviewStats,
    ...mealSelloutsV3,
    ...menusV3,
    ...permissions,
    ...quickFiltersV3,
    ...userBehavioralDiscounts,
    ...userBehavioralDiscountClaims,
    ...userV3,
  },
};
